/**
 * Bootstrap-only full-page loader HTML (main.tsx innerHTML before React mounts).
 * Class names are shared with FullPageLoader; styles live in index.css (.app-full-page-loader).
 * Keep React out of this module so the entry chunk does not pull the loader component graph early.
 */

/** Spinner size tokens (keep in sync with index.css `.app-loader-spinner*`). */
export const APP_LOADER_SPINNER_CLASS_LG = 'app-loader-spinner app-loader-spinner--lg';
export const APP_LOADER_SPINNER_CLASS_SM = 'app-loader-spinner app-loader-spinner--sm';

export const FULL_PAGE_LOADER_CLASSES = {
  root: 'app-full-page-loader',
  inner: 'app-full-page-loader__inner',
  spinner: APP_LOADER_SPINNER_CLASS_LG,
  text: 'app-full-page-loader__text',
} as const;

/**
 * Fixed full-screen overlay variant of the full-page loader (React-only, not used
 * by the pre-React bootstrap HTML). Escapes padded layout containers so the
 * background reaches every screen edge — used by the route-transition fallback.
 */
export const APP_FULL_PAGE_LOADER_OVERLAY_CLASS =
  'app-full-page-loader app-full-page-loader--overlay';

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function getFullPageLoaderBootstrapHtml(message = 'Laddar...'): string {
  const c = FULL_PAGE_LOADER_CLASSES;
  const safe = escapeHtml(message);
  return `<div class="${c.root}" role="status" aria-live="polite"><div class="${c.inner}"><div class="${c.spinner}" aria-hidden="true"></div><p class="${c.text}">${safe}</p></div></div>`;
}
